import { withInstall } from '@code-monkey-ui/utils'

import Divider from './src/divider.vue'

export const ElDivider = withInstall(Divider)
export default ElDivider

export * from './src/divider'
